var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessfull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.694,
    height: 70.029,
    viewBox: "0 0 49.694 70.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2168",
    "data-name": "Group 2168",
    transform: "translate(-173.845 -63.794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1949",
    "data-name": "Group 1949",
    transform: "translate(173.898 84.241)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_182",
    "data-name": "Ellipse 182",
    cx: 24.759,
    cy: 24.759,
    r: 24.759,
    transform: "translate(0 0)",
    fill: "#ec82ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1950",
    "data-name": "Group 1950",
    transform: "translate(180.98 91.097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3472",
    "data-name": "Path 3472",
    d: "M202.438,173.222a15.451,15.451,0,0,0-2.39,6.572c-.171,2.816.234,18.633.234,18.633l.073,1.048c4.457,5.212,21.069,13.109,35.25-.571h0l.818-9.183-2.408-20.595-8.364-2.048L223.69,163.9l-13.071,3.06-1.166,2.756Z",
    transform: "translate(-200.006 -163.899)",
    fill: "#fe0677"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2121",
    "data-name": "Group 2121",
    transform: "translate(185.157 63.794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2120",
    "data-name": "Group 2120",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2119",
    "data-name": "Group 2119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1958",
    "data-name": "Group 1958",
    transform: "translate(16.807 3.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1957",
    "data-name": "Group 1957"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1956",
    "data-name": "Group 1956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1955",
    "data-name": "Group 1955"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1954",
    "data-name": "Group 1954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1953",
    "data-name": "Group 1953"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1952",
    "data-name": "Group 1952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1951",
    "data-name": "Group 1951"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3473",
    "data-name": "Path 3473",
    d: "M278.738,92.633a38.5,38.5,0,0,0,1.341-6.5,13.44,13.44,0,0,0-.863-6.521c-.133-.308-1.238-2.366-1.57-2.316-.238.036.478,1.972.368,2.185a11.4,11.4,0,0,0-.939,6.7,30.015,30.015,0,0,0,1.663,6.452",
    transform: "translate(-276.945 -77.293)",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1961",
    "data-name": "Group 1961",
    transform: "translate(0 0.692)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1960",
    "data-name": "Group 1960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1959",
    "data-name": "Group 1959"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3474",
    "data-name": "Path 3474",
    d: "M233.705,76.208c-.106-5.556-3.427-10.125-8.977-9.866l-.512.054a9.934,9.934,0,0,0-8.891,10.122c.118,4.815.311,10.133.612,12.691.624,5.3,6.015,5.561,6.015,5.561s.247,3.483.247,3.483l2.278,2.475,10.558-6.54Z",
    transform: "translate(-215.322 -66.331)",
    fill: "#ffbf9d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1971",
    "data-name": "Group 1971",
    transform: "translate(6.63 26.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1970",
    "data-name": "Group 1970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1969",
    "data-name": "Group 1969"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1968",
    "data-name": "Group 1968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1967",
    "data-name": "Group 1967"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1966",
    "data-name": "Group 1966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1965",
    "data-name": "Group 1965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1964",
    "data-name": "Group 1964"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1963",
    "data-name": "Group 1963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1962",
    "data-name": "Group 1962"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3475",
    "data-name": "Path 3475",
    d: "M239.631,163.365a12.88,12.88,0,0,0,6.689-2.769,6.605,6.605,0,0,1-6.455,4.883Z",
    transform: "translate(-239.631 -160.596)",
    fill: "#ff9a6c"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1987",
    "data-name": "Group 1987",
    transform: "translate(3.051 14.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1986",
    "data-name": "Group 1986"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1985",
    "data-name": "Group 1985"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1984",
    "data-name": "Group 1984"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1983",
    "data-name": "Group 1983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1982",
    "data-name": "Group 1982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1981",
    "data-name": "Group 1981"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1980",
    "data-name": "Group 1980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1979",
    "data-name": "Group 1979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1978",
    "data-name": "Group 1978"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1977",
    "data-name": "Group 1977"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1976",
    "data-name": "Group 1976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1975",
    "data-name": "Group 1975"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1974",
    "data-name": "Group 1974"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1973",
    "data-name": "Group 1973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1972",
    "data-name": "Group 1972"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3476",
    "data-name": "Path 3476",
    d: "M226.511,117.469a.761.761,0,0,0,.811.687.728.728,0,0,0,.709-.765.762.762,0,0,0-.81-.688A.729.729,0,0,0,226.511,117.469Z",
    transform: "translate(-226.51 -116.702)",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2004",
    "data-name": "Group 2004",
    transform: "translate(1.352 11.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2003",
    "data-name": "Group 2003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2002",
    "data-name": "Group 2002"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2001",
    "data-name": "Group 2001"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2000",
    "data-name": "Group 2000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1999",
    "data-name": "Group 1999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1998",
    "data-name": "Group 1998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1997",
    "data-name": "Group 1997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1996",
    "data-name": "Group 1996"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1995",
    "data-name": "Group 1995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1994",
    "data-name": "Group 1994"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1993",
    "data-name": "Group 1993"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1992",
    "data-name": "Group 1992"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1991",
    "data-name": "Group 1991"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1990",
    "data-name": "Group 1990"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1989",
    "data-name": "Group 1989"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1988",
    "data-name": "Group 1988"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3477",
    "data-name": "Path 3477",
    d: "M220.3,108.739c.1.089.633-.4,1.448-.48s1.455.261,1.533.152c.039-.049-.076-.217-.356-.379a2.09,2.09,0,0,0-1.24-.244,2.007,2.007,0,0,0-1.14.505C220.311,108.512,220.245,108.7,220.3,108.739Z",
    transform: "translate(-220.28 -107.775)",
    fill: "#263238"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2020",
    "data-name": "Group 2020",
    transform: "translate(10.25 13.819)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2019",
    "data-name": "Group 2019"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2018",
    "data-name": "Group 2018"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2017",
    "data-name": "Group 2017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2016",
    "data-name": "Group 2016"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2015",
    "data-name": "Group 2015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2014",
    "data-name": "Group 2014"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2013",
    "data-name": "Group 2013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2012",
    "data-name": "Group 2012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2011",
    "data-name": "Group 2011"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2010",
    "data-name": "Group 2010"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2009",
    "data-name": "Group 2009"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2008",
    "data-name": "Group 2008"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2007",
    "data-name": "Group 2007"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2006",
    "data-name": "Group 2006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2005",
    "data-name": "Group 2005"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3478",
    "data-name": "Path 3478",
    d: "M252.9,115.227a.762.762,0,0,0,.811.687.728.728,0,0,0,.709-.765.762.762,0,0,0-.81-.688A.729.729,0,0,0,252.9,115.227Z",
    transform: "translate(-252.903 -114.46)",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2037",
    "data-name": "Group 2037",
    transform: "translate(9.369 11.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2036",
    "data-name": "Group 2036"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2035",
    "data-name": "Group 2035"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2034",
    "data-name": "Group 2034"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2033",
    "data-name": "Group 2033"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2032",
    "data-name": "Group 2032"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2031",
    "data-name": "Group 2031"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2030",
    "data-name": "Group 2030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2029",
    "data-name": "Group 2029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2028",
    "data-name": "Group 2028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2027",
    "data-name": "Group 2027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2026",
    "data-name": "Group 2026"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2025",
    "data-name": "Group 2025"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2024",
    "data-name": "Group 2024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2023",
    "data-name": "Group 2023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2022",
    "data-name": "Group 2022"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2021",
    "data-name": "Group 2021"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3479",
    "data-name": "Path 3479",
    d: "M249.688,106.863c.1.089.634-.4,1.449-.48s1.455.261,1.533.152c.038-.049-.075-.217-.356-.379a2.087,2.087,0,0,0-1.24-.244,2.008,2.008,0,0,0-1.14.505C249.7,106.636,249.637,106.823,249.688,106.863Z",
    transform: "translate(-249.672 -105.899)",
    fill: "#263238"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2053",
    "data-name": "Group 2053",
    transform: "translate(4.979 12.188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2052",
    "data-name": "Group 2052"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2051",
    "data-name": "Group 2051"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2050",
    "data-name": "Group 2050"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2049",
    "data-name": "Group 2049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2048",
    "data-name": "Group 2048"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2047",
    "data-name": "Group 2047"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2046",
    "data-name": "Group 2046"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2045",
    "data-name": "Group 2045"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2044",
    "data-name": "Group 2044"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2043",
    "data-name": "Group 2043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2042",
    "data-name": "Group 2042"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2041",
    "data-name": "Group 2041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2040",
    "data-name": "Group 2040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2039",
    "data-name": "Group 2039"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2038",
    "data-name": "Group 2038"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3480",
    "data-name": "Path 3480",
    d: "M235.719,115.311a5.42,5.42,0,0,0-1.349-.1c-.21,0-.412-.02-.462-.158a1.066,1.066,0,0,1,.074-.631q.214-.786.448-1.649a27.368,27.368,0,0,0,.945-4.29,27.4,27.4,0,0,0-1.288,4.2q-.221.867-.421,1.656a1.211,1.211,0,0,0-.022.828.525.525,0,0,0,.374.268,1.418,1.418,0,0,0,.359.012A5.336,5.336,0,0,0,235.719,115.311Z",
    transform: "translate(-233.576 -108.482)",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2069",
    "data-name": "Group 2069",
    transform: "translate(7.21 19.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2068",
    "data-name": "Group 2068"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2067",
    "data-name": "Group 2067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2066",
    "data-name": "Group 2066"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2065",
    "data-name": "Group 2065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2064",
    "data-name": "Group 2064"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2063",
    "data-name": "Group 2063"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2062",
    "data-name": "Group 2062"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2061",
    "data-name": "Group 2061"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2060",
    "data-name": "Group 2060"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2059",
    "data-name": "Group 2059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2058",
    "data-name": "Group 2058"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2057",
    "data-name": "Group 2057"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2056",
    "data-name": "Group 2056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2055",
    "data-name": "Group 2055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2054",
    "data-name": "Group 2054"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3481",
    "data-name": "Path 3481",
    d: "M244.126,134.657c-.133.006-.042.891-.733,1.6s-1.642.709-1.636.834c-.006.057.228.15.627.119a2.217,2.217,0,0,0,1.371-.646,1.929,1.929,0,0,0,.557-1.334C244.308,134.854,244.186,134.645,244.126,134.657Z",
    transform: "translate(-241.757 -134.656)",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2081",
    "data-name": "Group 2081",
    transform: "translate(9.073 8.341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2080",
    "data-name": "Group 2080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2079",
    "data-name": "Group 2079"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2078",
    "data-name": "Group 2078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2077",
    "data-name": "Group 2077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2076",
    "data-name": "Group 2076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2075",
    "data-name": "Group 2075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2074",
    "data-name": "Group 2074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2073",
    "data-name": "Group 2073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2072",
    "data-name": "Group 2072"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2071",
    "data-name": "Group 2071"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2070",
    "data-name": "Group 2070"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3482",
    "data-name": "Path 3482",
    d: "M248.6,95.171c.1.213.906.022,1.874.037.969,0,1.769.194,1.875-.018.046-.1-.11-.3-.444-.477a3.259,3.259,0,0,0-2.856-.014C248.709,94.877,248.551,95.07,248.6,95.171Z",
    transform: "translate(-248.589 -94.376)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2093",
    "data-name": "Group 2093",
    transform: "translate(1.39 9.21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2092",
    "data-name": "Group 2092"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2091",
    "data-name": "Group 2091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2090",
    "data-name": "Group 2090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2089",
    "data-name": "Group 2089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2088",
    "data-name": "Group 2088"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2087",
    "data-name": "Group 2087"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2086",
    "data-name": "Group 2086"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2085",
    "data-name": "Group 2085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2084",
    "data-name": "Group 2084"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2083",
    "data-name": "Group 2083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2082",
    "data-name": "Group 2082"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3483",
    "data-name": "Path 3483",
    d: "M220.447,98.567c.163.17.7-.081,1.378-.161.671-.1,1.26-.007,1.371-.215.048-.1-.062-.276-.33-.425a2.009,2.009,0,0,0-2.215.3C220.433,98.285,220.374,98.484,220.447,98.567Z",
    transform: "translate(-220.417 -97.562)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2101",
    "data-name": "Group 2101",
    transform: "translate(18.364 14.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2100",
    "data-name": "Group 2100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2099",
    "data-name": "Group 2099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2098",
    "data-name": "Group 2098"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2097",
    "data-name": "Group 2097"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2096",
    "data-name": "Group 2096"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2095",
    "data-name": "Group 2095"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2094",
    "data-name": "Group 2094"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3484",
    "data-name": "Path 3484",
    d: "M282.653,116.278c.086-.049,3.53-1.462,3.8,2.176s-3.44,3.154-3.454,3.051S282.653,116.278,282.653,116.278Z",
    transform: "translate(-282.653 -115.968)",
    fill: "#ffbf9d"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2110",
    "data-name": "Group 2110",
    transform: "translate(19.713 15.378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2109",
    "data-name": "Group 2109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2108",
    "data-name": "Group 2108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2107",
    "data-name": "Group 2107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2106",
    "data-name": "Group 2106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2105",
    "data-name": "Group 2105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2104",
    "data-name": "Group 2104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2103",
    "data-name": "Group 2103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2102",
    "data-name": "Group 2102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3485",
    "data-name": "Path 3485",
    d: "M287.6,123.107c.015-.013.067.04.177.081a.634.634,0,0,0,.474-.025,1.571,1.571,0,0,0,.622-1.46,2.1,2.1,0,0,0-.244-.894.735.735,0,0,0-.512-.452.323.323,0,0,0-.361.2c-.041.105-.013.176-.032.184s-.082-.055-.064-.208a.406.406,0,0,1,.127-.238.48.48,0,0,1,.344-.118.892.892,0,0,1,.7.515,2.157,2.157,0,0,1,.294,1,1.65,1.65,0,0,1-.81,1.638.68.68,0,0,1-.586-.054C287.615,123.194,287.59,123.114,287.6,123.107Z",
    transform: "translate(-287.6 -120.178)",
    fill: "#ff9a6c"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2118",
    "data-name": "Group 2118",
    transform: "translate(1.839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2117",
    "data-name": "Group 2117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2116",
    "data-name": "Group 2116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2115",
    "data-name": "Group 2115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2114",
    "data-name": "Group 2114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2113",
    "data-name": "Group 2113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2112",
    "data-name": "Group 2112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2111",
    "data-name": "Group 2111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3486",
    "data-name": "Path 3486",
    d: "M222.194,68.491c-.61-.287,1.035-2.308,2.44-3.058,2.124-1.134,5.425-1.96,7.479-1.517a8.787,8.787,0,0,1,5.93,3.743,14.344,14.344,0,0,1,2.077,7.206,4.358,4.358,0,0,1-.37,2.257c-.457.837-1.4,1.407-1.285,2.514a1.528,1.528,0,0,1-.307,1.135c-.62.751-1.478.138-1.9-.505a10.555,10.555,0,0,1-1.266-4.7,10.657,10.657,0,0,1,.007-3.476c.139-.618.388-1.21.493-1.834a2.192,2.192,0,0,0-.375-1.8,2.283,2.283,0,0,0-.315-.28A3.8,3.8,0,0,0,231,67.7c-2,.857-5.433,2.165-6.392,1.528a5.618,5.618,0,0,1-1.736-1.548Z",
    transform: "translate(-222.064 -63.794)"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2122",
    "data-name": "Group 2122",
    transform: "translate(176.119 100.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3487",
    "data-name": "Path 3487",
    d: "M189.477,198.083c-.211.292-3.192,1.281-4.323,3.165s-2.25,10.345-2.25,10.345l-.72,5.57a47.793,47.793,0,0,0,5.339,7.309Z",
    transform: "translate(-182.184 -198.083)",
    fill: "#fe0677"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2124",
    "data-name": "Group 2124",
    transform: "translate(205.811 108.589)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2123",
    "data-name": "Group 2123",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3488",
    "data-name": "Path 3488",
    d: "M291.047,228.033a14.36,14.36,0,0,0,.644,3.356,4.831,4.831,0,0,0,2.074,2.634,5.911,5.911,0,0,1,1.241.71c.376.35.566.857.907,1.242a3.566,3.566,0,0,0,1.53.9,13.446,13.446,0,0,0,5.078.809c.053-.584.057-2.728.111-3.312Z",
    transform: "translate(-291.047 -228.033)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2157",
    "data-name": "Group 2157",
    transform: "translate(204.371 90.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2128",
    "data-name": "Group 2128",
    transform: "translate(6.141 6.059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2125",
    "data-name": "Group 2125",
    transform: "translate(0.043 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3489",
    "data-name": "Path 3489",
    d: "M312.877,183.063s3.759,1.112,4.86,2.713,3.053,7.808,3.453,8.959.05,3.82-.7,5.739-2.053,3.57-4.3,3.82-5.807-1.051-6.607-1.9a6.691,6.691,0,0,1-1.134-2.76,21.208,21.208,0,0,0,2.951-.74",
    transform: "translate(-308.444 -183.063)",
    fill: "#fe0677"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2127",
    "data-name": "Group 2127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2126",
    "data-name": "Group 2126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3490",
    "data-name": "Path 3490",
    d: "M311.279,198.889a.2.2,0,0,1-.047.02l-.142.051c-.126.043-.314.106-.562.18a20.076,20.076,0,0,1-2.194.525l.03-.043a9.264,9.264,0,0,0,.384,1.379,5.5,5.5,0,0,0,.325.738,2.6,2.6,0,0,0,.5.686,3.637,3.637,0,0,0,.76.5,9.048,9.048,0,0,0,.885.406,13.992,13.992,0,0,0,2,.632,10.094,10.094,0,0,0,2.243.288c.2.009.39-.017.587-.027a5.231,5.231,0,0,0,.586-.1,4.1,4.1,0,0,0,1.129-.438,5.105,5.105,0,0,0,1.792-1.749,9.276,9.276,0,0,0,1.065-2.417,13.881,13.881,0,0,0,.434-2,9.5,9.5,0,0,0,.1-1.978,3.473,3.473,0,0,0-.2-.934l-.3-.907-.586-1.754c-.387-1.14-.769-2.219-1.151-3.218a19.958,19.958,0,0,0-1.209-2.71,3.213,3.213,0,0,0-.849-.95,7.27,7.27,0,0,0-.956-.641,15.064,15.064,0,0,0-1.666-.806c-.47-.195-.841-.331-1.094-.42l-.288-.1a.6.6,0,0,1-.1-.038.525.525,0,0,1,.1.024l.292.088c.256.081.631.208,1.105.4a14.421,14.421,0,0,1,1.684.788,7.268,7.268,0,0,1,.973.639,3.3,3.3,0,0,1,.879.968,19.694,19.694,0,0,1,1.233,2.72c.388,1,.775,2.078,1.165,3.218l.591,1.754.3.906a3.614,3.614,0,0,1,.2.967,9.6,9.6,0,0,1-.1,2.009,13.943,13.943,0,0,1-.438,2.021,9.383,9.383,0,0,1-1.083,2.453,5.232,5.232,0,0,1-1.843,1.792,4.228,4.228,0,0,1-1.165.449,5.375,5.375,0,0,1-.6.106c-.2.01-.4.036-.6.026a10.176,10.176,0,0,1-2.272-.3,14,14,0,0,1-2.012-.647,9.163,9.163,0,0,1-.893-.416,3.733,3.733,0,0,1-.779-.522,2.693,2.693,0,0,1-.518-.715,5.593,5.593,0,0,1-.325-.752,9.179,9.179,0,0,1-.373-1.4l-.007-.037.037-.006a22.414,22.414,0,0,0,2.2-.49l.567-.161.145-.041A.2.2,0,0,1,311.279,198.889Z",
    transform: "translate(-308.285 -183.061)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2130",
    "data-name": "Group 2130",
    transform: "translate(10.106 14.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2129",
    "data-name": "Group 2129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3491",
    "data-name": "Path 3491",
    d: "M328.747,220.4c-.028.007-.113-.463-.429-1.155a7.9,7.9,0,0,0-1.7-2.408,5.554,5.554,0,0,0-1.318-.939l-.332-.149a3.078,3.078,0,0,0-.326-.106,3.036,3.036,0,0,0-.6-.124l-.137-.021h-.371a1.745,1.745,0,0,0-.383.033,1.529,1.529,0,0,1-.331.034,1.475,1.475,0,0,1,.322-.088,1.584,1.584,0,0,1,.388-.058l.246-.011.135-.005.141.016a2.978,2.978,0,0,1,.624.111,3.061,3.061,0,0,1,.338.1l.345.148a5.42,5.42,0,0,1,1.359.953,7.416,7.416,0,0,1,1.69,2.471,4.307,4.307,0,0,1,.179.488,3.184,3.184,0,0,1,.1.378A1.5,1.5,0,0,1,328.747,220.4Z",
    transform: "translate(-322.821 -215.407)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2132",
    "data-name": "Group 2132",
    transform: "translate(10.784 13.173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2131",
    "data-name": "Group 2131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3492",
    "data-name": "Path 3492",
    d: "M332.606,212.477a6.922,6.922,0,0,0-.567-1.145,4.475,4.475,0,0,0-2.4-1.813,7.712,7.712,0,0,0-3.056-.168l-.935.112a1.654,1.654,0,0,1-.346.028,1.611,1.611,0,0,1,.337-.083c.218-.043.536-.1.931-.157a7.289,7.289,0,0,1,3.111.132,4.28,4.28,0,0,1,1.516.828,4.47,4.47,0,0,1,.922,1.067,3.85,3.85,0,0,1,.4.861A1.279,1.279,0,0,1,332.606,212.477Z",
    transform: "translate(-325.307 -209.145)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2134",
    "data-name": "Group 2134",
    transform: "translate(10.803 12.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2133",
    "data-name": "Group 2133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3493",
    "data-name": "Path 3493",
    d: "M329.823,205.607a8.36,8.36,0,0,0-4.445.175,2.211,2.211,0,0,1,.616-.258,6.2,6.2,0,0,1,3.2-.126A2.22,2.22,0,0,1,329.823,205.607Z",
    transform: "translate(-325.378 -205.247)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2136",
    "data-name": "Group 2136",
    transform: "translate(8.92 6.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2135",
    "data-name": "Group 2135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3494",
    "data-name": "Path 3494",
    d: "M318.719,186.5c.022,0-.032.383-.076,1a15.062,15.062,0,0,0,.4,4.7l-.1.032c-.112-.315-.2-.571-.257-.749a.147.147,0,1,1,.054-.02c.074.172.176.422.3.733l-.1.032a12.534,12.534,0,0,1-.4-4.74c.034-.309.075-.558.108-.728A1,1,0,0,1,318.719,186.5Z",
    transform: "translate(-318.472 -186.503)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2154",
    "data-name": "Group 2154",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2137",
    "data-name": "Group 2137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3495",
    "data-name": "Path 3495",
    d: "M289.621,160.846a2.327,2.327,0,0,0-2.2,2.345,32.357,32.357,0,0,0,0,4.336c0,.788-.347,3.591-.347,3.591a3.992,3.992,0,0,0-1.309,2.6,1.989,1.989,0,0,0,1.036,1.861,2.406,2.406,0,0,0,.563,2.59,3,3,0,0,0-.1,2.188,2.094,2.094,0,0,0,1.171.909,1.33,1.33,0,0,0,.808,1.83,5.806,5.806,0,0,0,2.028.249l1.456-.028,1.283.708s2.2-.957,2.252-2.252l.056-1.295a26.333,26.333,0,0,1-.676-2.815c-.056-.676.507-2.309.169-3.041s-1.52-1.162-1.408-2.186a2.427,2.427,0,0,0-.619-2.15,15.77,15.77,0,0,0-2.747-1.689,10.571,10.571,0,0,1-.576-2.759C290.466,164.711,291.592,161.276,289.621,160.846Z",
    transform: "translate(-285.769 -160.846)",
    fill: "#ffbf9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2139",
    "data-name": "Group 2139",
    transform: "translate(1.309 8.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2138",
    "data-name": "Group 2138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3496",
    "data-name": "Path 3496",
    d: "M294.426,190.822a2.9,2.9,0,0,1-.54.35c-.343.2-.821.469-1.354.759s-1.019.544-1.374.723a2.925,2.925,0,0,1-.589.263,2.916,2.916,0,0,1,.541-.351c.343-.2.821-.469,1.354-.758s1.018-.544,1.374-.722A2.912,2.912,0,0,1,294.426,190.822Z",
    transform: "translate(-290.568 -190.82)",
    fill: "#ff9a6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2141",
    "data-name": "Group 2141",
    transform: "translate(1.118 12.585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2140",
    "data-name": "Group 2140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3497",
    "data-name": "Path 3497",
    d: "M295.2,206.988c.006.008-.055.062-.17.152s-.288.214-.508.357a10.079,10.079,0,0,1-3.806,1.457c-.259.041-.47.065-.616.073a.708.708,0,0,1-.229,0,8.265,8.265,0,0,1,.827-.172,12.452,12.452,0,0,0,3.772-1.444A8.251,8.251,0,0,1,295.2,206.988Z",
    transform: "translate(-289.869 -206.986)",
    fill: "#ff9a6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2143",
    "data-name": "Group 2143",
    transform: "translate(7.358 11.183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2142",
    "data-name": "Group 2142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3498",
    "data-name": "Path 3498",
    d: "M313.511,201.847c.035.012-.038.263-.269.472s-.486.26-.495.224.2-.14.4-.329S313.474,201.83,313.511,201.847Z",
    transform: "translate(-312.747 -201.846)",
    fill: "#ff9a6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2145",
    "data-name": "Group 2145",
    transform: "translate(1.499 16.445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2144",
    "data-name": "Group 2144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3499",
    "data-name": "Path 3499",
    d: "M297.085,221.143a4.238,4.238,0,0,1-.816.3,15.955,15.955,0,0,1-4.135.665,4.229,4.229,0,0,1-.869-.028,6.948,6.948,0,0,1,.864-.073c.533-.037,1.267-.107,2.072-.236s1.523-.294,2.041-.425A6.938,6.938,0,0,1,297.085,221.143Z",
    transform: "translate(-291.265 -221.14)",
    fill: "#ff9a6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2147",
    "data-name": "Group 2147",
    transform: "translate(8.765 13.321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2146",
    "data-name": "Group 2146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3500",
    "data-name": "Path 3500",
    d: "M318.241,212.488a3.737,3.737,0,0,1,.15-.418,2.363,2.363,0,0,0-.241-2.013,3.682,3.682,0,0,1-.244-.371c.011-.013.157.088.327.314a2.139,2.139,0,0,1,.251,2.105A.889.889,0,0,1,318.241,212.488Z",
    transform: "translate(-317.905 -209.685)",
    fill: "#ff9a6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2149",
    "data-name": "Group 2149",
    transform: "translate(2.606 20.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2148",
    "data-name": "Group 2148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3501",
    "data-name": "Path 3501",
    d: "M300.137,235.575a2.827,2.827,0,0,1-.693.164,10.663,10.663,0,0,1-3.428-.01,2.849,2.849,0,0,1-.692-.167,4.727,4.727,0,0,1,.706.068,15.084,15.084,0,0,0,3.4.01A4.657,4.657,0,0,1,300.137,235.575Z",
    transform: "translate(-295.323 -235.556)",
    fill: "#ff9a6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2151",
    "data-name": "Group 2151",
    transform: "translate(2.003 4.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2150",
    "data-name": "Group 2150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3502",
    "data-name": "Path 3502",
    d: "M295.066,178.637c.008.015-.088.088-.271.154a1.717,1.717,0,0,1-1.456-.173c-.162-.106-.238-.2-.227-.213a2.442,2.442,0,0,0,1.953.232Z",
    transform: "translate(-293.112 -178.401)",
    fill: "#ff9a6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2153",
    "data-name": "Group 2153",
    transform: "translate(8.76 16.288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2152",
    "data-name": "Group 2152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3503",
    "data-name": "Path 3503",
    d: "M318.634,220.566a.536.536,0,0,1,.031.211,2.4,2.4,0,0,1-.068.575c-.053.239-.143.514-.229.819a2.316,2.316,0,0,0-.1.993c.047.345.305.625.346.976a1.3,1.3,0,0,1-.214.844,2.947,2.947,0,0,1-.352.459c-.093.1-.15.149-.157.143s.187-.239.422-.651a1.24,1.24,0,0,0,.172-.775c-.033-.3-.294-.576-.356-.97a2.33,2.33,0,0,1,.116-1.054c.095-.308.193-.577.257-.807A5.084,5.084,0,0,0,318.634,220.566Z",
    transform: "translate(-317.888 -220.566)",
    fill: "#ff9a6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2156",
    "data-name": "Group 2156",
    transform: "translate(7.813 18.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2155",
    "data-name": "Group 2155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3504",
    "data-name": "Path 3504",
    d: "M316.842,226.848a.971.971,0,0,1,.091.256c.049.168.114.412.176.719a6.482,6.482,0,0,1,.13,1.095,2.924,2.924,0,0,1-.247,1.336,3.822,3.822,0,0,1-.838,1.068,7.622,7.622,0,0,1-.866.68c-.259.176-.475.306-.628.392a.956.956,0,0,1-.245.119c-.012-.019.315-.225.814-.592a8.965,8.965,0,0,0,.835-.694,3.88,3.88,0,0,0,.8-1.035,2.9,2.9,0,0,0,.244-1.273,7.346,7.346,0,0,0-.1-1.079C316.91,227.229,316.82,226.853,316.842,226.848Z",
    transform: "translate(-314.416 -226.848)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2159",
    "data-name": "Group 2159",
    transform: "translate(189.325 96.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2158",
    "data-name": "Group 2158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3505",
    "data-name": "Path 3505",
    d: "M235.309,187.653a2.11,2.11,0,0,1-.316-.236l-.826-.684-.566-.478a1.632,1.632,0,0,0-.322-.231.4.4,0,0,0-.365-.013c-.235.123-.392.425-.593.676l-.6.81-.939,1.256-.176.236.056-.289a14.211,14.211,0,0,1,.679-2.379c.11-.285.207-.508.277-.658a1.073,1.073,0,0,1,.121-.227,1.156,1.156,0,0,1-.079.244c-.057.155-.141.382-.24.669a16.727,16.727,0,0,0-.625,2.376l-.12-.053.934-1.261.6-.808.289-.384a1.051,1.051,0,0,1,.361-.327.529.529,0,0,1,.477.019,1.689,1.689,0,0,1,.343.254l.555.491.8.718A2.119,2.119,0,0,1,235.309,187.653Z",
    transform: "translate(-230.604 -185.437)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2161",
    "data-name": "Group 2161",
    transform: "translate(194.722 96.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2160",
    "data-name": "Group 2160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3506",
    "data-name": "Path 3506",
    d: "M261.217,185.1a.554.554,0,0,1-.107.1l-.322.251-1.2.9-4.013,2.954-.061.045-.041-.064-.1-.156-2.014-3.179.074.024a15.032,15.032,0,0,0-2.235,1.115c-.258.156-.457.286-.592.373a1.324,1.324,0,0,1-.212.129,1.226,1.226,0,0,1,.191-.159c.13-.1.322-.236.576-.4a13.46,13.46,0,0,1,2.228-1.168l.046-.019.027.043,2.032,3.168.1.156-.1-.019,4.038-2.919,1.228-.868.337-.23A.588.588,0,0,1,261.217,185.1Z",
    transform: "translate(-250.391 -185.105)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2163",
    "data-name": "Group 2163",
    transform: "translate(181.036 107.728)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2162",
    "data-name": "Group 2162",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3507",
    "data-name": "Path 3507",
    d: "M200.245,224.875a1,1,0,0,1,.015.193c0,.14.009.324.015.552.009.5.022,1.185.038,2.03.032,1.714.1,4.081.19,6.7s.142,4.985.148,6.7c0,.858,0,1.551-.007,2.031,0,.228-.009.412-.012.552a.1.1,0,1,1-.029,0c0-.14-.009-.324-.015-.552-.009-.5-.022-1.185-.038-2.03-.032-1.714-.1-4.081-.19-6.7s-.141-4.984-.148-6.7c0-.857,0-1.552.007-2.031,0-.228.009-.412.012-.552A.988.988,0,0,1,200.245,224.875Z",
    transform: "translate(-200.212 -224.875)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2165",
    "data-name": "Group 2165",
    transform: "translate(193.499 101.681)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2164",
    "data-name": "Group 2164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3508",
    "data-name": "Path 3508",
    d: "M246.529,233.389a.336.336,0,0,1-.014-.079c-.007-.06-.016-.136-.026-.232l-.087-.892c-.076-.775-.163-1.9-.25-3.287s-.162-3.045-.209-4.885-.05-3.864-.007-5.987.147-4.146.267-5.983.271-3.488.421-4.871.283-2.5.392-3.273l.126-.887.036-.23a.332.332,0,0,1,.017-.078.34.34,0,0,1,0,.08l-.022.232c-.024.214-.057.512-.1.89-.092.772-.213,1.892-.347,3.276s-.271,3.035-.391,4.87-.206,3.856-.255,5.977-.037,4.143,0,5.981.1,3.493.178,4.882.146,2.512.2,3.288c.026.38.046.679.061.894,0,.1.009.172.012.233A.323.323,0,0,1,246.529,233.389Z",
    transform: "translate(-245.907 -202.706)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2167",
    "data-name": "Group 2167",
    transform: "translate(173.845 85.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2166",
    "data-name": "Group 2166",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3509",
    "data-name": "Path 3509",
    d: "M185.994,145.649s-.1.067-.288.193l-.853.554c-.374.244-.808.589-1.336.972-.26.2-.522.433-.812.672l-.446.375c-.151.131-.3.279-.45.424a24.358,24.358,0,0,0-3.945,4.736l-.485.78c-.171.261-.3.55-.461.83s-.314.567-.456.867l-.419.918c-.069.156-.146.31-.21.471l-.186.489c-.123.329-.255.659-.376,1-.2.692-.457,1.389-.609,2.132a25.086,25.086,0,0,0-.384,9.838,24.694,24.694,0,0,0,39.374,15.637,26.126,26.126,0,0,0,2.439-2.128l.553-.578c.186-.19.366-.385.536-.588l.519-.6.488-.619a24.5,24.5,0,0,0,4.8-10.872,25.032,25.032,0,0,0,.324-2.784c.029-.459.029-.916.044-1.369-.009-.452-.033-.9-.049-1.347q-.013-.334-.026-.665c-.013-.22-.049-.438-.073-.655q-.079-.652-.156-1.292c-.068-.424-.166-.839-.245-1.253a11.292,11.292,0,0,0-.284-1.219l-.34-1.18a4.85,4.85,0,0,0-.193-.572l-.21-.56c-.145-.369-.264-.744-.427-1.1l-.487-1.042a24.518,24.518,0,0,0-4.706-6.647,25.619,25.619,0,0,0-4.862-3.789l-1.041-.6a4.81,4.81,0,0,0-.485-.25l-.459-.219-.816-.389c-.246-.125-.487-.2-.693-.282l-.948-.367c-.213-.083-.322-.13-.322-.13s.111.037.326.116l.954.355c.207.084.449.153.7.276l.82.383.461.216a4.82,4.82,0,0,1,.487.247l1.047.594a25.5,25.5,0,0,1,4.89,3.781,24.527,24.527,0,0,1,4.74,6.659l.491,1.045c.164.353.284.73.431,1.1l.212.562a4.943,4.943,0,0,1,.194.575l.343,1.185a11.375,11.375,0,0,1,.288,1.224c.081.416.18.833.248,1.258q.079.643.159,1.3c.024.218.06.437.074.658s.018.444.028.668c.016.447.041.9.051,1.353-.015.455-.014.914-.043,1.375a25.091,25.091,0,0,1-.322,2.8,24.61,24.61,0,0,1-4.813,10.934l-.49.623-.521.6c-.171.2-.352.4-.539.592l-.556.581a26.2,26.2,0,0,1-2.452,2.141,24.819,24.819,0,0,1-39.574-15.729,25.152,25.152,0,0,1,.4-9.881c.155-.746.412-1.445.616-2.139.122-.341.255-.672.379-1l.188-.49c.064-.161.142-.316.212-.472l.423-.921c.143-.3.31-.583.46-.869s.293-.57.465-.831l.489-.781a24.265,24.265,0,0,1,3.974-4.733c.156-.145.3-.291.453-.422l.449-.373c.292-.238.556-.473.818-.669.532-.38.969-.723,1.346-.963l.861-.543C185.892,145.708,185.994,145.649,185.994,145.649Z",
    transform: "translate(-173.845 -143.449)",
    fill: "#263238"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessfull);
export default __webpack_public_path__ + "static/media/Successfull.8ee4c988fce9cb7eff4dffb196dbbf35.svg";
export { ForwardRef as ReactComponent };